// extracted by mini-css-extract-plugin
module.exports = {"moreItems":"az_C6b"};